{
  "version": 1,
  "asset_id": "cc3a5522-f014-4fbb-8504-584704a60db0",
  "project_id": "1e2975bf-5ed0-490a-887a-32746528c0b1",
  "url": "/__l5e/assets-v1/cc3a5522-f014-4fbb-8504-584704a60db0/unyque-pro.webp",
  "r2_key": "a/v1/1e2975bf-5ed0-490a-887a-32746528c0b1/cc3a5522-f014-4fbb-8504-584704a60db0/unyque-pro.webp",
  "original_filename": "unyque-pro.webp",
  "size": 22064,
  "content_type": "image/webp",
  "created_at": "2026-09-21T21:17:08Z"
}
